import { sharedQueryParams } from 'shared-helpers';

export const prepareFilterParam = sharedQueryParams.prepareFilterParam;
export const prepareSelectParam = sharedQueryParams.prepareSelectParam;
export const prepareSortParam = sharedQueryParams.prepareSortParam;